import * as React from "react";
import Popover from "@mui/material/Popover";
import Popper from '@mui/material/Popper';

import Typography from "@mui/material/Typography";
import styled from "styled-components";
import Video from "../Video";
import Markdown from "markdown-to-jsx";

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Button = styled.button `
  background: none;
`

const ImageContainer = styled.img`
  max-width: calc(30vw + 120px);
  max-height: 60vh;
`;

const PopoverContentContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

const TextWrapper = styled.div`
  max-width: calc(30vw + 120px);
`;

export default function HoverIcon({ comment, media }) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const MediaProcessor = ({ media }) => {
    if (
      media.ext == ".GIF" ||
      media.ext == ".gif" ||
      media.ext == ".png" ||
      media.ext == ".jpg"
    ) {
      return <ImageContainer src={media.url} />;
    }
    if (media.ext == ".mp4" || media.ext == ".mov") {
      return <Video videoSrcURL={media.url} />;
    }
  };

  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;


  return (
    <Container>
      <Button
        aria-describedby={id}
        variant="contained"
        onClick={handlePopoverOpen}
      >
        💬
      </Button>
      <Popover
        keepMounted
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handlePopoverClose}
        anchorOrigin={{
          vertical: 'center',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'center',
          horizontal: 'right',
        }}
        // sx={{
        //   maxWidth: "1000px",
        // }}
      >
        <PopoverContentContainer>
          <TextWrapper>
            {comment && (
              <Typography sx={{ p: 1 }}>
                <Markdown>{comment}</Markdown>
              </Typography>
            )}
          </TextWrapper>
          {media && open && <MediaProcessor media={media} />}
        </PopoverContentContainer>
      </Popover>
    </Container>
  );
}
